import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchItemCardModelsIfNeeded } from '@/redux/modules/itemCardModel';
import { fetchRecentItemsIfNeeded, getLimitedSortedRecentItemIdsFromState } from '@/redux/modules/recentItem';

export default ({ store }: DataLoaderParams) => {
    const { dispatch, getState } = store;

    return dispatch(fetchRecentItemsIfNeeded()).then(() => {
        const state = getState();
        const itemIds = getLimitedSortedRecentItemIdsFromState(state, 72);
        return dispatch(fetchItemCardModelsIfNeeded(itemIds, 'RECENT-ITEMS-PAGE-DATA'));
    });
};
